import { DatePicker, Spinner } from '@platform/components';

type MatchConfirmingContentProps = {
  startDate: Date;
  setStartDate: (date: Date) => void;
  endDate: Date;
  setEndDate: (date: Date) => void;
  isSaving: boolean;
};

export const MatchConfirmingContent = (props: MatchConfirmingContentProps) => {
  const { startDate, setStartDate, endDate, setEndDate, isSaving } = { ...props };
  return (
    <div className='flex flex-col gap-8 items-center md:mt-8 md:w-[500px]'>
      {isSaving ?
        <Spinner />
      : <>
          <div className='text-center text-lg'>
            What should we use for your project dates? We use these to track your progress, but you
            can change them later if you need to.
          </div>
          <div className='flex flex-col gap-1 w-full'>
            <div className='text-sm text-gray-500'>Start date</div>
            <DatePicker
              additionalClassNames={'w-full md:w-[500px]'}
              initialDate={startDate}
              onChange={(newDate) => setStartDate(newDate)}
              helpTextHeader="What's this?"
              helpTextBody="We default to today's date"
              minDate={new Date()}
            />
          </div>
          <div className='flex flex-col gap-1 w-full'>
            <div className='text-sm text-gray-500'>End date</div>
            <DatePicker
              additionalClassNames={'w-full md:w-[500px]'}
              initialDate={endDate}
              onChange={(newDate) => setEndDate(newDate)}
              helpTextHeader="What's this?"
              helpTextBody='We default to 3 months, but feel free to adjust based on your situation'
              minDate={new Date()}
            />
          </div>
        </>
      }
    </div>
  );
};
